import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InspectionPointService } from '../../shared/services/index';
import { InspectionPoint } from '../../shared/models/index';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    selector: 'point-edit-page',
    templateUrl: './edit.component.html',
    standalone: false
})
export class PointEditPageComponent extends BaseModalPageComponent implements OnInit {
  public point: InspectionPoint;
  inspectionId: string;
  pointId: string;
  public processing = false;

  constructor(
    location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pointService: InspectionPointService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.pointId = pointId;

      this.initData();
    });
  }

  initData(): void {
    this.pointService.getPoint(this.inspectionId, this.pointId).subscribe((data) => {
      this.point = data;
      if (this.point.inspection.parts) this.point.inspection.parts.point = this.point;
    });
  }

  savePoint(point: InspectionPoint): void {
    this.processing = true;
    this.pointService
      .updatePointProperties(this.inspectionId, this.pointId, { name: point.name, description: point.description })
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  cancel(): void {
    this.goToBack();
  }
}
